<div class="audit-wrapper">
  <div class="audit-banner"></div>

  <div class="card results-card">
    <div class="header-texts">
      <app-info-alert title="Resultado del perfilamiento">
        Observe el resultado obtenido. Solo se habilitará el siguiente paso para
        los integrantes que cumplan con los criterios definidos en el
        perfilamiento.
      </app-info-alert>
    </div>

    <div class="mx-4">
      <div class="table-responsive">
        <table class="audit-table">
          <thead>
            <tr>
              <th (click)="ordenarPor('no')">
                No.
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th (click)="ordenarPor('identificacion')">
                Identificación
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th (click)="ordenarPor('nombreUsuario')">
                Nombre usuario
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
              <th (click)="ordenarPor('resultado')">
                Resultado
                <mat-icon class="sort-icon">unfold_more</mat-icon>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let resultado of dataParaMostrar; trackBy: trackByNumero"
            >
              <td>{{ resultado.no }}</td>
              <td>{{ resultado.identificacion }}</td>
              <td>{{ resultado.nombreUsuario }}</td>
              <td>
                <div class="result-cell">
                  <mat-icon
                    [ngStyle]="{
                      color: resolverEstado(resultado.resultado.codigo).color,
                    }"
                  >
                    {{ resolverEstado(resultado.resultado.codigo).icono }}
                  </mat-icon>
                  <span class="result-label">{{
                    resultado.resultado.resultado
                  }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="warning-row" *ngIf="mensajeBloqueo">
    <mat-icon>warning</mat-icon>
    <span>{{ mensajeBloqueo }}</span>
  </div>

  <div *ngIf="mostrarPregunta" class="question-block">
    <p class="question-title">
      ¿El solicitante desea continuar con el proceso teniendo en cuenta el
      resultado?
    </p>
    <div class="options-row">
      <label class="option-pill" [class.active]="selectedDecision === 'si'">
        <input
          type="radio"
          name="continuar"
          [value]="'si'"
          [disabled]="readonly"
          (change)="seleccionarDecision('si')"
        />
        <mat-icon>{{
          selectedDecision === "si" ? "check_box" : "check_box_outline_blank"
        }}</mat-icon>
        <span>Si</span>
        <button
          mat-icon-button
          matTooltip="Seleccione 'Si' si el solicitante confirma que desea seguir con el proceso de traslado y luego seleccione el botón 'Siguiente'."
          tabindex="-1"
        >
          <mat-icon>info_outline</mat-icon>
        </button>
      </label>

      <label class="option-pill" [class.active]="selectedDecision === 'no'">
        <input
          type="radio"
          name="continuar"
          [value]="'no'"
          [disabled]="readonly"
          [checked]="selectedDecision === 'no'"
          (change)="seleccionarDecision('no')"
        />
        <mat-icon>{{
          selectedDecision === "no" ? "check_box" : "check_box_outline_blank"
        }}</mat-icon>
        <span>No</span>
        <button
          mat-icon-button
          #noHelp="matTooltip"
          matTooltip="Seleccione 'No' en caso de que el solicitante no desee seguir con el proceso de traslado."
          (click)="toggleTooltip(noHelp, $event)"
          tabindex="-1"
        >
          <mat-icon>info_outline</mat-icon>
        </button>
      </label>
    </div>
  </div>

  <div class="actions-row ml-4">
    <button
      class="btn btn-primary btn-icon w-80"
      [disabled]="botonSiguienteDeshabilitado"
      (click)="continuarPaso()"
    >
      Siguiente
    </button>
  </div>

  <div class="info-row" *ngIf="anuladoMensaje">
    <mat-icon>info</mat-icon>
    <span>{{ anuladoMensaje }}</span>
  </div>

  <div class="error-row" *ngIf="anuladoErrorMensaje">
    <mat-icon>error</mat-icon>
    <span>{{ anuladoErrorMensaje }}</span>
  </div>

  <div class="error-row" *ngIf="mensajeErrorValidacion">
    <mat-icon>error</mat-icon>
    <span>{{ mensajeErrorValidacion }}</span>
    <button class="btn-primary" (click)="reintentarAuditoria()">
      Reintentar auditoría
    </button>
  </div>

  <ng-template #confirmNoTemplate>
    <div class="modal-header-content">
      <mat-icon color="primary">help</mat-icon>
      <p class="m-0">
        La novedad se radicará en estado <strong>anulado</strong>. ¿Está de
        acuerdo?
      </p>
    </div>
  </ng-template>
</div>
